<template>
  <ul :id="'company-' + model.id">
    <li @click="onDepotClick" class="company" :class="selected ? 'active' : null">
      <a
        data-toggle="collapse"
        :href="'#company-' + model.id + '-details'"
        role="button"
        aria-expanded="false"
        aria-controls="company"
        class="d-block company__name"
      >
        <span
          class="company__car-count"
          :class="getVehicleCount() ? model.marker_color.key : MarkerColorKey.RED"
        >{{ getVehicleCount() }}</span>
        {{ model.name }}
        <span class="icon-plus"></span>
      </a>
      <div class="company__distance">
        <span
          v-if="model.state && model.state.distance"
        >{{ model.state.distance | distance }} {{ i18n.app.text.from_standed_vehicle }}</span>
      </div>
      <div class="collapse" :id="'company-' + model.id + '-details'">
        <div class="card card-body">
          <DepotInfoItem :model="model" v-bind:key="model.id" :padding="padding" />
        </div>
      </div>
    </li>

    <VehicleListItem
      v-for="vehicle in vehicles"
      v-bind:key="vehicle.id"
      @book="onBookClick"
      :model="vehicle"
    />
  </ul>
</template>

<script>
import { VehicleListItem } from "@/components/crud/vehicle";
import DepotInfoItem from "./DepotInfoItem";
import { MarkerColorKey } from "@/models/MarkerColor";

export default {
  name: "depot-item",
  props: ["model", "selected", "padding"],
  components: {
    VehicleListItem,
    DepotInfoItem
  },
  data() {
    return {
      vehicles: [],
      MarkerColorKey: MarkerColorKey
    };
  },
  mounted() {
    this.sortVehicles();
  },
  methods: {
    onDepotClick() {
      this.$emit("onDepotClick", this.model);
    },
    onBookClick(vehicle) {
      this.$emit("onBookClick", vehicle);
    },
    getVehicleCount() {
      return this.model?.state?.available_vehicles
        ? this.model.state.available_vehicles.length
        : this.model.vehicles
        ? this.model.vehicles.length
        : null;
    },
    sortVehicles() {
      const modelVehicles = this.model?.state?.available_vehicles ? this.model.state.available_vehicles : this.model.vehicles || [];
      this.vehicles = modelVehicles.sort((vehicle, otherVehicle) =>
        vehicle.sort_title > otherVehicle.sort_title ? 1 : -1
      );
    }
  },
  filters: {
    distance: value => {
      return value ? parseFloat(value + "").toFixed(1) + " km" : "? km";
    },
    slice: (value, start, end) => {
      return value ? value.substring(start, end) : value;
    }
  }
};
</script>
